import { render, staticRenderFns } from "./SysPost.vue?vue&type=template&id=2d8ec5b8&scoped=true"
import script from "./SysPost.vue?vue&type=script&lang=js"
export * from "./SysPost.vue?vue&type=script&lang=js"
import style0 from "./SysPost.vue?vue&type=style&index=0&id=2d8ec5b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ec5b8",
  null
  
)

export default component.exports